<template>
    <!-- TODO - EPIC-1000 EPIC : Soap migration -->
    <b-tab title-link-class="p-0" v-if="_hasAccess('patient.attachment.view')">
        <template v-slot:title>
            <b-nav-item-dropdown no-flip name="tab-items">
                <template slot="button-content">
                    <i class="cus-folder-picture"></i>
                    Documents
                </template>
                <b-dropdown-item
                    v-if="_hasAccess('patient.letter.view')"
                    @click="showList(DOCUMENTS.VIEWS.LETTERS)"
                >
                    <i class="cus-page-white-text"></i>
                    View Letters {{ stats ? `(${stats.total_letter})` : "(0)" }}
                </b-dropdown-item>
                <b-dropdown-item @click="showList(DOCUMENTS.VIEWS.ATTACHMENTS)">
                    <i class="cus-page-attach"></i>
                    View Attachments
                    {{ stats ? `(${stats.total_attachment})` : "(0)" }}
                </b-dropdown-item>
                <b-dropdown-item @click="showList(DOCUMENTS.VIEWS.WEBFORMS)">
                    <i class="cus-application-form-edit"></i>
                    View Forms {{ stats ? `(${stats.total_form})` : "(0)" }}
                </b-dropdown-item>

                <li
                    v-if="!statusInActive && isOwner(soapDetails.business_id)"
                    class="dropdown-divider"
                ></li>

                <b-dropdown-item
                    v-if="
                        !statusInActive &&
                        isOwner(soapDetails.business_id) &&
                        _hasAccess('patient.letter.create')
                    "
                    @click.stop="openModal(DOCUMENTS.VIEWS.LETTERS)"
                >
                    <i class="cus-add"></i>
                    New Letter
                </b-dropdown-item>
                <b-dropdown-item
                    v-if="
                        _hasAccess('patient.attachment.create') &&
                        !statusInActive &&
                        isOwner(soapDetails.business_id)
                    "
                    @click.stop="openModal(DOCUMENTS.VIEWS.ATTACHMENTS)"
                >
                    <i class="cus-add"></i>
                    New Attachment
                </b-dropdown-item>
                <b-dropdown-item
                    v-if="!statusInActive && isOwner(soapDetails.business_id)"
                    @click.stop.prevent="openModal(DOCUMENTS.VIEWS.WEBFORMS)"
                >
                    <i class="cus-add"></i>
                    New Form
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </template>
        <b-card-text id="tab-document-content">
            <Letters
                v-if="selectedOption === DOCUMENTS.VIEWS.LETTERS"
                :key="keyview"
                :patientId="soapDetails.patient_id"
                :soapId="soapDetails.id"
                v-on="$listeners"
            />
            <Attachment
                v-if="selectedOption === DOCUMENTS.VIEWS.ATTACHMENTS"
                :key="keyview"
                :patientDetails="soapDetails.patient"
                :soapId="soapDetails.id"
                v-on="$listeners"
            />
            <ListWebforms
                v-if="selectedOption === DOCUMENTS.VIEWS.WEBFORMS"
                :patientId="soapDetails.patient_id"
                :soapId="soapDetails.id"
                :key="keyview"
                module="soap"
                v-on="$listeners"
            />
        </b-card-text>
    </b-tab>
</template>

<script>
import DOCUMENTS from "@/constants/documents";

export default {
    components: {
        Letters: () =>
            import("@/components/patient-documents/document-list-letters"),
        ListWebforms: () =>
            import("@/components/webform/document-list-webforms"),
        Attachment: () =>
            import("@/components/patient-documents/document-list-attachments")
    },
    computed: {
        soapDetails() {
            return this.$store.getters["soap/soapDetails"];
        },
        statusInActive() {
            return this.$store.getters["soap/patientStatusInActive"];
        },
        stats() {
            return this.$store.getters["soap/documentsCountsSoap"];
        }
    },
    data() {
        return {
            keyview: 0,
            selectedOption: DOCUMENTS.VIEWS.LETTERS,
            DOCUMENTS
        };
    },
    watch: {},
    methods: {
        showList(code) {
            this.keyview += 1;
            this.selectedOption = code;

            this.$emit("scroll-to-element", "tab-document-content");
        },
        openModal(key) {
            if (key === DOCUMENTS.VIEWS.LETTERS) {
                this.$store.commit("patient/openModalNewLetter");
            } else if (key === DOCUMENTS.VIEWS.ATTACHMENTS) {
                this.$store.commit("patient/openModalNewAttachment");
            } else {
                this.$emit("open-modal", key);
            }
        }
    }
};
</script>
